import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { useMutation } from '@apollo/react-hooks';
import { SAVE_VISUALIZER } from '../../Queries';
import { saveVisualizer, getVisualizerNoun } from '../../Utils/VisualizerUtils';

import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

import { StyledPinkButton } from '../AccountVisualizer/AccountVisualizerStyles';
import { StyledFlexWrapper } from './VisualizerSaveModalStyles';

var _ref3 = React.createElement(
  'h3',
  null,
  'Name your design.'
);

var _ref4 = React.createElement(LoadingSpinner, null);

var VisualizerSaveForm = function VisualizerSaveForm(_ref) {
  var queryParams = _ref.queryParams,
      setVisualizerTitle = _ref.setVisualizerTitle,
      user = _ref.user,
      selectedProducts = _ref.selectedProducts;

  var _useMutation = useMutation(SAVE_VISUALIZER),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      saveVisualizerMutation = _useMutation2[0];

  return React.createElement(
    Formik,
    {
      initialValues: {
        title: ''
      },
      validate: function validate(values) {
        var errors = {};
        if (!values.title) {
          errors.title = 'Please name your ' + getVisualizerNoun().toLowerCase() + '.';
        }
        if (values.title.length > 20) {
          errors.title = 'Sorry! That\'s too long (20 character limit)';
        }
        return errors;
      },
      onSubmit: function onSubmit(values, actions) {
        saveVisualizer({
          saveVisualizerMutation: saveVisualizerMutation,
          queryParams: queryParams,
          title: values.title,
          user: user,
          selectedProducts: selectedProducts,
          onSuccessFunc: function onSuccessFunc() {
            setVisualizerTitle(values.title);
            actions.setSubmitting(false);
          }
        });
      }
    },
    function (_ref2) {
      var errors = _ref2.errors,
          isSubmitting = _ref2.isSubmitting;

      return React.createElement(
        Form,
        null,
        React.createElement(
          StyledFlexWrapper,
          null,
          _ref3,
          React.createElement(
            'p',
            null,
            errors.title
          ),
          React.createElement(Field, {
            name: 'title',
            type: 'text',
            placeholder: 'Name goes here',
            maxLength: '21'
          }),
          React.createElement(
            StyledPinkButton,
            { type: 'submit', disabled: isSubmitting },
            isSubmitting ? _ref4 : 'Save'
          )
        )
      );
    }
  );
};

VisualizerSaveForm.propTypes = {
  setVisualizerTitle: PropTypes.func,
  queryParams: PropTypes.string,
  user: PropTypes.object,
  selectedProducts: PropTypes.array
};

export default VisualizerSaveForm;